import Vue from "vue";
import VueRouter from "vue-router";
// import productService from "../views/productService.vue";
// import Login from "../views/login.vue";
// import Home from "../views/home.vue";
// import Case from "../views/case.vue";
// import Product from "../views/product.vue";
// import Consult from "../views/consult.vue";
// import Cooperation from "../views/cooperation.vue";
// import About from "../views/about.vue";
// import ChangePwd from "../views/changepwd.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/", name: "Home", component:  () => import("@/views/home.vue"),
    meta: { title: '政企电话卡_AI工作手机_物联网_零信任组网加速-用友通信[官网]', isKeepAlive: true}
  },
  {
    path: "/case/:type", name: "Case", component:  () => import("@/views/case.vue"),
    meta: { title: '案例' },
  },
  {
    path: "/product/:type", name: "Product", component: () => import("@/views/product.vue"),
    meta: { title: '产品' },
  },
  {
    path: "/consult", name: "Consult", component: () => import("@/views/consult.vue"),
    meta: { title: '业务咨询', }
  },
  {
    path: "/cooperation", name: "Cooperation", component: () => import("@/views/cooperation.vue"),
    meta: { title: '商务伙伴', }
  },
  {
    path: "/about", name: "About", component: () => import("@/views/about.vue"),
    meta: { title: '关于我们', }
  },
  {
    path: "/419/:type", name: "419Market", component: () => import("@/views/419.vue"),
    meta: { title: '', }
  },
  {
    path: "/sus", name: "419Sus", component: () => import("@/views/419sus.vue"),
    meta: { title: '', }
  },
  {
    path: "/activity", name: "activity", component: () => import("@/views/activity.vue"),
    meta: { title: '用友通信代理招募', }
  },
  {
    path: "/activityvivo", name: "activityvivo", component: () => import("@/views/activityVivo.vue"),
    meta: { title: 'vivo用友电销机-智慧电销 管理有道', }
  },
  {
    path: "/400", name: "400", component: () => import("@/views/400.vue"),
    meta: { title: '400服务', }
  },
  {
    path: "/login", name: "Login", component: () => import("@/views/login.vue"),
    meta: { title: '登录', }
  },
  {
    path: "/register", name: "Register", component: () => import("@/views/register.vue"),
    meta: { title: '注册', }
  },
  {
    path: "/resetpassword", name: "ResetPassword", component: () => import("@/views/resetPassword.vue"),
    meta: { title: '找回密码', }
  },
  {
    path: "/changepwd", name: "ChangePwd", component: () => import("@/views/changepwd.vue"),
    meta: { title: '修改密码', }
  },
  {
    path: "/enterprise-define/login", name: "enterpriseDefineLogin", component: () => import("@/views/enterprise-define/login.vue"),
    meta: { title: '登录', }
  },
];

// 是否需要判断未登录的时候跳转登录页

const router = new VueRouter({
  // mode: "history",
  // base: process.env.BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }

  next()

  if (
    window.location.host !== 'dev.csp.yonyoutelecom.cn' &&
    window.location.host !== 'test.csp.yonyoutelecom.cn' &&
    window.location.host !== 'csp.yonyoutelecom.cn' &&
    window.location.host !== 'www.yonyoutelecom.cn' &&
    window.location.host !== 'yonyoutelecom.cn' &&
    window.location.host !== 'localhost:8086'
  ) {
    // 自定义界面的
    const defineRouteList = ['enterpriseDefineLogin', 'Register', 'ResetPassword', 'ChangePwd']
    if (defineRouteList.indexOf(to.name) == -1) {
      next({ name: 'enterpriseDefineLogin', replace: true })
    } else {
      next()
    }
  } else {
    next()
  }
})


export default router;
